// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_hp","dropdown__list":"_hq","dropdown__item":"_hr","dropdown__bell":"_hs"};